import { getDictOne } from "@/utils/storage";
const CodeList = getDictOne('industry_code');
const industryDictList = [];
CodeList.map((a) => {
    let obj = {}
    obj.value = a.dictKey;
    obj.label = a.dictValue
    industryDictList.push(obj);
})

export const formConfig = (data = {}) => [
    {
        type: 'text', require: true, max: 50, label: '企业名称', name: 'auditMechanismName', value: data.auditMechanismName, placeholder: '请输入企业名称'
    },
    {
        type: 'area', require: true, max: 50, label: '所在地', name: 'auditMechanismLocation', value: data.auditMechanismLocation, placeholder: '请输入所在地'
    },
    {
        type: 'text', require: true, max: 50, label: '详细地址', name: 'auditMechanismAddress', value: data.auditMechanismAddress, placeholder: '请输入详细地址'
    },
    {
        type: 'text', require: true, max: 50, label: '统一社会信用代码', name: 'auditMechanismCode', value: data.auditMechanismCode, placeholder: '请输入统一社会信用代码',
        pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/
    },
    {
        type: 'text', require: true, max: 50, label: '企业规模', name: 'auditMechanismScale', value: data.auditMechanismScale, placeholder: '请输入企业规模'
    },
    {
        type: 'select', require: true, max: 50, label: '企业性质', name: 'auditMechanismNature', value: data.auditMechanismNature, placeholder: '请输入企业性质', options: [{
            value: '1',
            label: '国有企业'
        }, {
            value: '2',
            label: '私营企业'
        }, {
            value: '3',
            label: '外资企业'
        }]
    },
    {
        type: 'select', require: true, max: 50, label: '所属行业', name: 'auditMechanismIndustry', value: data.auditMechanismIndustry, placeholder: '请输入所属行业', options: industryDictList
    },
    {
        type: 'text', require: true, max: 50, label: '企业类型', name: 'auditMechanismType', value: `${data.auditMechanismType == 0 ? '招聘企业' : data.auditMechanismType == 1 ? '培训机构' : data.auditMechanismType == 2 ? '金融机构' : ''}`, placeholder: '请输入企业类型'
    },
    {
        type: 'text', require: true, max: 20, label: '机构法人', name: 'auditMechanismLegalPerson', value: data.auditMechanismLegalPerson, placeholder: '请输入机构法人'
    },
    {
        type: 'text', require: true, max: 20, label: '联系人', name: 'auditMechanismContacts', value: data.auditMechanismContacts, placeholder: '请输入联系人'
    },
    {
        type: 'text', require: true, max: 20, label: '联系电话', name: 'phone', value: data.phone, placeholder: '请输入联系电话', pattern: /(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$)|(^1[3456789]\d{9}$)/
    },
    {
        type: 'text', require: true, max: 30, label: '企业邮箱', name: 'email', value: data.email, placeholder: '请输入企业邮箱',
        pattern: /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/
    },
    {
        type: 'text', require: true, max: 500, label: '企业简介', name: 'auditMechanismIntroduce', value: data.auditMechanismIntroduce, placeholder: '请输入企业简介'
    },

]
